function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M51.733 28.533c0 13.465-10.916 24.381-24.381 24.381S2.971 41.998 2.971 28.533 13.887 4.152 27.352 4.152C27 10 27 12 34 12c-5 3-1 15 9 7-1.392 7.619 4.568 6.127 7.898 3.185.545 2.024.835 4.152.835 6.348"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 18,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 27.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21.5,
  cy: 38.5,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 34,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 30,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38.5,
  cy: 7.5,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 11,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 49,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 43.5,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37.5,
  cy: 16.5,
  r: 0.5
}));

var SvgCookie = function SvgCookie(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCookie, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cookie.58fa5f05.svg";
export { ForwardRef as ReactComponent };